import { render, staticRenderFns } from "./Home.pug?vue&type=template&id=44655de5&lang=pug&external"
import script from "./Home.js?vue&type=script&lang=js&external"
export * from "./Home.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports